import {Injectable} from '@angular/core';
import {HttpModelConverter} from '../../../../core/converter/httpModel.converter';
import {MessageModel} from '../messageModel';
import {DocumentSummaryConverter} from '../../../../document/common/api/converter/DocumentSummary.converter';
import {UserSummaryConverter} from '../../../../account/modules/user/api/converter/userSummary.converter';
import {MomentAdapter} from '../../../../../shared/utils/moment.utils';
import {LovValueSummaryConverter} from "../../../../common/lov/lov-value/api/converter/LovValueSummary.converter";
import {ExternalIdConverter} from "../../../../common/externalId/api/entity/converter/externalId.converter";
import {MessageSummaryModel} from "../messageSummary.model";
import {PermissionsConverter} from "../../../../common/converter/permissions.converter";
import {EntityWithAuditMetadataConverter} from "../../../../common/converter/entityWithAuditMetadata.converter";

@Injectable({
    providedIn: 'root'
})
export class MessageSummaryConverter extends HttpModelConverter<MessageSummaryModel> {

    constructor(private lovValueSummaryConverter: LovValueSummaryConverter,
                private externalIdConverter: ExternalIdConverter,
                private permissionConverter: PermissionsConverter,
                private entityWithAuditMetadataConverter: EntityWithAuditMetadataConverter,
                private userSummaryConverter: UserSummaryConverter) {
        super();
    }
    protected createInstance(): MessageSummaryModel {
        return new MessageSummaryModel();
    }

    protected enrichObject(result: MessageSummaryModel, src: MessageSummaryModel) {
        result.externalId = this.externalIdConverter.convert(src.externalId);
        result.externalProcessId = this.externalIdConverter.convert(src.externalProcessId);
        result.externalProcessStatus = this.lovValueSummaryConverter.convert(src.externalProcessStatus);
        result.permissions = this.permissionConverter.convert(src.permissions);
        this.entityWithAuditMetadataConverter.convert(result, src);
        result.author = this.userSummaryConverter.convert(src.author);
    }
}
